import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class EstateUpsellClearWillMeta extends BaseModel {
  /**
   * @var {number}
   */
  parentId;

  /**
   * @var {string}
   */
  requestToUpgradePlan;

  /**
   * @var {boolean}
   */
  needsSpouseTestamentGuidance;

  /**
   * @var {boolean}
   */
  needsExecutorGuidance;

  /**
   * @var {boolean}
   */
  needsAssetOwnershipGuidance;

  /**
   * @var {boolean}
   */
  needsSpecificGiftImpactGuidance;

  /**
   * @var {boolean}
   */
  needsContingencyPlanningGuidance;

  /**
   * @var {boolean}
   */
  needsTrustSolutionsGuidance;

  /**
   * @var {boolean}
   */
  needsClearEstateExecutorshipGuidance;

  /**
   * @var {boolean}
   */
  needsFamilySpecificGuidance;

  constructor(model = {}) {
    super();
    this.parentId = model.parentId;
    this.requestToUpgradePlan = model.requestToUpgradePlan;
    this.needsSpouseTestamentGuidance = model.needsSpouseTestamentGuidance;
    this.needsExecutorGuidance = model.needsExecutorGuidance;
    this.needsAssetOwnershipGuidance = model.needsAssetOwnershipGuidance;
    this.needsSpecificGiftImpactGuidance = model.needsSpecificGiftImpactGuidance;
    this.needsContingencyPlanningGuidance = model.needsContingencyPlanningGuidance;
    this.needsTrustSolutionsGuidance = model.needsTrustSolutionsGuidance;
    this.needsClearEstateExecutorshipGuidance = model.needsClearEstateExecutorshipGuidance;
    this.needsFamilySpecificGuidance = model.needsFamilySpecificGuidance;
  }

  /**
   * @returns {boolean}
   */
  get hasPlanSelected() {
    return !!this.requestToUpgradePlan;
  }

  /**
   * @param {string} value
   */
  setPlan(value) {
    this.requestToUpgradePlan = value;
  }
}
